import styled from 'styled-components';
import { color } from 'theme';

export const StyledFaqs = styled.div`
  background-color: ${color('sand_100')};
`;
